import { GRID_SIZE } from './gridsize';

export const SCROLL_DELAY = 100;
export const SCROLL_TO_DURATION = 600;
export const SCROLL_TO_TOP_DURATION = 1500;
export const PERMALINK_DELAY = SCROLL_TO_DURATION + 100;
export const COMMENT_PERMALINK_SCROLL_OFFSET = GRID_SIZE * 2;
export const LINE_PERMALINK_SCROLL_OFFSET = GRID_SIZE / 2;
export const SIDEBAR_EXPANDER_SCROLL_OFFSET = 2 * (GRID_SIZE * 4);
